var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.27726V11.5031C0 11.7764 0.223579 12 0.496843 12H2.7227C2.85685 12 2.98106 11.9453 3.07546 11.8559L9.30089 5.63044C9.49466 5.43667 9.49466 5.12366 9.30089 4.92989L7.07505 2.70404C6.88128 2.51027 6.56827 2.51027 6.3745 2.70404L0.149062 8.92948C0.0546618 9.01891 0 9.14311 0 9.27726Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8497 2.37119L9.62387 0.145326C9.4301 -0.0484422 9.1171 -0.0484422 8.92333 0.145326L7.7309 1.33776C7.53713 1.53153 7.53713 1.84453 7.7309 2.0383L9.95676 4.26416C10.1505 4.45792 10.4635 4.45792 10.6573 4.26416L11.8497 3.07174C12.0435 2.88294 12.0435 2.56496 11.8497 2.37119Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputPenIcon);
export default __webpack_public_path__ + "static/media/input-pen-icon.69e92b25b46652052686e7d2f5bfd948.svg";
export { ForwardRef as ReactComponent };